import { Stack } from "@chakra-ui/react";

import { useAccountLookupStore } from "../../hooks/useAccountLookupStore";
import { AppRoutes } from "../../routes";
import {
  RouteTab,
  RouteTabList,
  RouteTabPanel,
  RouteTabPanels,
  RouteTabs,
} from "../RouteTabs";
import BookingTab from "./BuyingPowerTab/BuyingPowerTab";
import RequirementsAndActivityTab from "./RequirementsAndActivityTab";
import SummaryTab from "./SummaryTab/SummaryTab";

export default function MarginAccountDetailsTabs() {
  const { accountNumber } = useAccountLookupStore();
  return (
    <>
      <Stack flex="1 1 0" height="100%">
        <RouteTabs
          routeParam="tab"
          h="full"
          display="flex"
          flexDirection="column"
        >
          <RouteTabList
            mb={4}
            zIndex="auto"
            data-testid="margin-account-details-tabs"
          >
            <RouteTab
              href={`/${AppRoutes.MarginAccountDetails}/${accountNumber}`}
              routeName=""
              data-testid="tab-summary"
            >
              Summary
            </RouteTab>
            <RouteTab
              href={`/${AppRoutes.MarginAccountDetails}/${accountNumber}/buying-power`}
              routeName="buying-power"
            >
              Buying Power
            </RouteTab>
            <RouteTab
              href={`/${AppRoutes.MarginAccountDetails}/${accountNumber}/requirements`}
              routeName="requirements"
            >
              Requirements & Activity
            </RouteTab>
          </RouteTabList>
          <RouteTabPanels h="full">
            <RouteTabPanel routeName="">
              <SummaryTab />
            </RouteTabPanel>
            <RouteTabPanel routeName="buying-power">
              <BookingTab />
            </RouteTabPanel>
            <RouteTabPanel routeName="requirements" h="full">
              <RequirementsAndActivityTab />
            </RouteTabPanel>
          </RouteTabPanels>
        </RouteTabs>
      </Stack>
    </>
  );
}
